import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { SafeHtml } from '@partsbadger/library';
import UserStore from '../../../stores/UserStore';

export const ShowEmail = () => {
    let notification_id = '';
    ({ notification_id } = useParams());
    const [notification, setNotification] = useState<{
        content: string;
        created_time: string;
        id: number;
        read: boolean;
        sent: boolean;
        title: string;
        url: string | null;
    } | null>(null);

    useEffect(() => {
        UserStore.getNotification(Number(notification_id)).then(response => setNotification(response));
    }, []);

    return (
        <div className={'mt-4'}>
            {notification && <SafeHtml html={notification.content} />}
        </div>
    );
};
